import styled, { css } from "styled-components";
import { FlexRow } from "app/components/React/Table/cells/DomainListWithTooltip/styled";

export const CellContainer = styled(FlexRow)`
    align-items: center;
    gap: 8px;

    & .bold {
        font-weight: 700;
    }
`;
export const ColorContainer = styled.div<{ color: string }>`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;

    ${({ color }) =>
        css`
            background-color: ${color};
        `};
`;
